/**
 * @license Copyright (c) 2017-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import $ from 'jquery';

export function enableCollapsables() {
	const classExp = 'toggler--expanded';
	const classCol = 'toggler--collapsed';

	enableCollapsable( {
		selector: `.tree li[class*="toggler--"]`,
		nodeElement: 'li',
		dontToggleClass: 'tree__item__text',

		collapsedClass: classCol,
		expandedClass: classExp
	} );

	enableCollapsable( {
		selector: '.collapsing-list__term[class*="toggler--"]',
		nodeElement: '.collapsing-list__term',
		dontToggleClass: [ 'collapsing-list__type', 'collapsing-list__dev-names--active' ],

		collapsedClass: classCol,
		expandedClass: classExp
	} );
}

function enableCollapsable( options ) {
	$( options.selector ).on( 'click', function( evt ) {
		const clicked = $( this );
		const target = $( evt.target );
		const parentNode = target.closest( options.nodeElement );

		if ( parentNode.is( options.selector ) ) {
			if ( ( target.is( 'a' ) || target.is( 'code' ) ) && hasClassFrom( target, options.dontToggleClass ) ) {
				return;
			}

			clicked.toggleClass( `${ options.expandedClass } ${ options.collapsedClass }` );
			evt.stopPropagation();
		}
	} );

	function hasClassFrom( target, classArray ) {
		let ret = false;
		if ( typeof classArray === 'string' ) {
			return target.hasClass( classArray );
		}
		classArray.forEach( cls => {
			if ( target.hasClass( cls ) ) {
				ret = true;
			}
		} );
		return ret;
	}
}

export function hideTogglers() {
	$( '.collapsing-list__item' ).each( function() {
		const excerpt = $( this ).find( '.collapsing-list__excerpt' );
		const term = $( this ).children( '.collapsing-list__term' );

		// If there is no excerpt it means that API item has no description at all so we can hide the toggler.
		if ( excerpt.length === 0 ) {
			term.addClass( 'hidden' );
		} else {
			const el = excerpt[ 0 ];
			// Checking absolute value between scrollWidth and offsetWidth becaue when window is zoomed out these values differ by 1.
			const excerptHasEllipsis = Math.abs( el.scrollWidth - el.offsetWidth ) > 3;
			const descriptionContent = $( this ).find( '.collapsing-list__content' );

			// If excerpt has no ellipsis, which means it's short, and item detailed description is empty.
			// Then we also can hide the toggler.
			if ( !excerptHasEllipsis && !descriptionContent.text().trim() ) {
				term.addClass( 'hidden' );
			}
		}
	} );
}
